export default __webpack_public_path__ + "static/graphic_nps-46b190659f580722aa9dfc881fea9095.svg";